module.exports = __webpack_public_path__ + "static/media/T+T_GraceBeck_-25.0edc78a6.JPG";